const $ = require('jquery');

module.exports = function (contentOverlayService) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.contentOverlay = contentOverlayService;
            scope.body = $('body');

            scope.close = function () {
                if (scope.contentOverlay.callback) {
                    scope.contentOverlay.callback();
                }
                scope.contentOverlay.close();
            };

            scope.$watch('contentOverlay.isOpen', (isOpen) => {
                // prevent scroll on body
                if (isOpen) {
                    scope.body.addClass('overlay-is-open');
                } else {
                    scope.body.removeClass('overlay-is-open');
                }
            });

        },
        template: require('./content-overlay-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/contentoverlay/content-overlay-directive.js
 **/